import UIComponent from "../../common/UIComponent";
import SwitchComponent from "../switch/index";
import "./index.css";
export default class BarrageContainer extends UIComponent {

  constructor(elementId, interfaces) {
    super()
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();
  }

  init() {

    this.barrageContainer = document.createElement("div");
    this.barrageContainer.setAttribute("class", "vhallPlayer-barrage-box");
    this.appendChild(this.elementId, this.barrageContainer);

    new SwitchComponent(".vhallPlayer-barrage-box", this.interfaces, {
      text: "弹",
      id: "barrage",
      openCallback: this.handleSwitchOpen,
      closeCallback: this.handleSwitchClose
    });

    // 组件容器
    this.barrageInputBox = document.createElement("div");
    this.barrageInputBox.setAttribute("class", "vhallPlayer-barrageInput-box");

    // 输入框容器
    this.inputBox = document.createElement("div");
    this.inputBox.setAttribute("class", "input-box");

    //输入框
    this.input = document.createElement("input");
    this.input.setAttribute("placeholder", "我想说~");
    this.input.setAttribute("type", "text");
    this.input.oninput = this.handleInput.bind(this);

    // 发送按钮
    this.button = document.createElement("button");
    this.button.setAttribute("class", "sendBarrage");
    this.button.innerText = "发送";
    this.button.onclick = this.handleButtonClick.bind(this)

    this.inputBox.appendChild(this.input);
    this.inputBox.appendChild(this.button);
    this.barrageInputBox.appendChild(this.inputBox);
    this.barrageContainer.appendChild(this.barrageInputBox);
    // this.appendChild(this.elementId, this.barrageContainer);


  }


  handleInput(event) {
    this.inputValue = event.target.value;
  }

  handleButtonClick() {
    this.interfaces.addBarrage(this.inputValue);
    this.input.value = "";
  }
  
  handleSwitchOpen() {
    this.interfaces.openBarrage();
  }

  handleSwitchClose() {
    this.interfaces.closeBarrage();
  }

}